import { Component, OnInit, Renderer2 } from "@angular/core";
import { Title } from "@angular/platform-browser";

import { UnitSharedService } from "@Unit/shared/services/unitshared.service";
import { PORTAL_STYLES } from "@Unit/shared/Type/config/portal-style.config";
import { PortalStyle } from "@Unit/shared/Type/Interfaces/portal-style.interface";

import { HeaderService } from "../Header/header.service";
interface RouteData {
  title: string;
}

@Component({
  selector: "app-portales",
  templateUrl: "./portales.component.html",
  styleUrls: ["./portales.component.scss"],
})
export class PortalesComponent implements OnInit {
  public toggledSidebar = false;
  public isUserSignedIn: boolean = false;
  public hideUserHeader: boolean = false;
  public isLoaded = false;

  constructor(
    private titleService: Title,
    private renderer: Renderer2,
    private headerService: HeaderService,
    private unitSharedService: UnitSharedService
  ) {
    this.headerService.routesData$.subscribe((data: RouteData[]) => {
      this.updateTitle(data);
    });
  }

  public ngOnInit(): void {
    this.unitSharedService.isUnitPortalStyle$.subscribe((isUnitStyle) => {
      const portalStyleConfig = isUnitStyle ? PORTAL_STYLES.unit : PORTAL_STYLES.universal;
      this.applyPortalStyle(portalStyleConfig);
    });
  }

  public onSidebarToggled(): void {
    this.toggledSidebar = !this.toggledSidebar;
  }

  private applyPortalStyle(portalStyleConfig: PortalStyle): void {
    // Aplicamos los estilos según el portal style actual
    this.updateStyles(portalStyleConfig.stylesClass);
    this.titleService.setTitle(portalStyleConfig.title);
    document.title = portalStyleConfig.title;
    this.updateFavicon(portalStyleConfig.favicon);

    this.isLoaded = true;
  }

  private updateTitle(data: RouteData[]): void {
    if (data.length < 2) {
      this.titleService.setTitle(document.title);
    } else {
      const title = data.slice(-2).reduce((acc, curr) => (acc ? curr.title + " - " + acc : curr.title), "");
      this.titleService.setTitle(title);
    }
  }

  private updateStyles(stylesClass: string): void {
    const body = document.body;
    if (stylesClass) {
      this.renderer.addClass(body, stylesClass);
    } else {
      this.renderer.removeClass(body, "style-unit");
    }
  }

  private updateFavicon(iconUrl: string): void {
    const link: HTMLLinkElement = this.renderer.createElement("link");
    link.rel = "icon";
    link.href = iconUrl;
    const head = document.head;
    const existingLink = head.querySelector('link[rel="icon"]');
    if (existingLink) {
      head.removeChild(existingLink);
    }
    head.appendChild(link);
  }
}
